// eslint-disable-next-line @typescript-eslint/no-var-requires
var compare = require('semver-compare');
/**
 * @description 是否大于某个版本
 */
export function gt(a, b) {
    return compare(a, b) === 1;
}
/**
 * @description 是否低于某个版本
 */
export function lt(a, b) {
    return compare(a, b) === -1;
}
/**
 * @description 是否等于某个版本
 */
export function eq(a, b) {
    return compare(a, b) === 0;
}
/**
 * @description 是否大于等于某个版本
 */
export function ge(a, b) {
    return gt(a, b) || eq(a, b);
}
/**
 * @description 是否低于等于某个版本
 */
export function le(a, b) {
    return lt(a, b) || eq(a, b);
}
